/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';

import {
	// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
	createResource,
	type Match,
	type Query,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { fetchProjectSidebarConnectNavigationInfo } from '../../../services/sidebar/project-sidebar-connect-addons-navigation/main.tsx';
import type { ProjectSidebarAddonNavItem } from '../../../services/sidebar/project-sidebar-connect-addons-navigation/types.tsx';

const getIdentifier = (match: Match, query: Query): string => {
	const { projectKey, projectId } = getProjectKeyId(match, query);
	return projectKey || projectId;
};

export const staticJSMProjectConnectAddonsNavigationResource: RouteResource<
	ProjectSidebarAddonNavItem[] | null
> = createResource<ProjectSidebarAddonNavItem[] | null>({
	type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
	getKey: ({ match, query }) => getIdentifier(match, query) ?? 'none',
	getData: async ({ match, query }) => {
		const projectKeyOrId = getIdentifier(match, query);
		if (projectKeyOrId == null) {
			return null;
		}
		const navInfo = await fetchProjectSidebarConnectNavigationInfo(projectKeyOrId, 'jsm_queues');
		return navInfo;
	},
	maxAge: 5 * 60 * 1000,
});
